module.exports = __webpack_public_path__ + "img/gc_white.2b0c946c.svg";